<script lang="ts">
  import type { Prompt } from '$routes/auth/account/_components/auth';
  import { createEventDispatcher } from 'svelte';
  import { goto } from '$app/navigation';
  import Login from '$routes/auth/account/_components/Login.svelte';
  import Create from '$routes/auth/account/_components/Create.svelte';
  import SuitUp from '$routes/auth/account/_components/SuitUp.svelte';

  const dispatch = createEventDispatcher();

  export let flow: 'login' | 'create' | 'suit-up';
  export let variant: 'full' | 'contained' = 'full';
  export let redirectUrl: string | null = null;
  export let namePrefilled: string = '';
  export let prompt: Prompt | null = null;
  export let callback: (() => Promise<void>) | (() => void) | null = null;
  export let switchHref = false;
  let className = 'mt-8 h-full max-w-[400px] xl:mt-0 xl:max-w-[960px] shadow-newLg rounded-3xl';
  export { className as class };

  async function done() {
    if (callback) {
      await callback();
    }

    if (redirectUrl) {
      await goto(redirectUrl);
    }

    dispatch('done');
  }
</script>

{#if flow === 'login'}
  <Login
    class={className}
    {variant}
    {switchHref}
    on:switch={() => (flow = 'create')}
    on:needsUsername={() => (flow = 'suit-up')}
    on:done={done}
  />
{:else if flow === 'create'}
  <Create
    class={className}
    {variant}
    {switchHref}
    {prompt}
    on:switch={() => (flow = 'login')}
    on:needsUsername={() => (flow = 'suit-up')}
  />
{:else if flow === 'suit-up'}
  <SuitUp name={namePrefilled} {variant} class={className} on:done={done} />
{/if}
